import { CKLayoutHorizontal } from 'clearkit';

import { UniversalSearch } from '~/components/CommandBar/UniversalSearch';

export const HomeSidebarSearch = () => {
  return (
    <header className="px-8">
      <CKLayoutHorizontal className="pb-8 border-b border-gray-200">
        <UniversalSearch placeholder="Search your accounts, contacts, and segments" />
      </CKLayoutHorizontal>
    </header>
  );
};
